<template>
  <v-radio-group v-bind="$attrs" color="interactive">
    <template v-slot:label>
      <div class="text-wrap">
        <slot name="label" />
      </div>
    </template>
    <slot>
      <qtm-radio
        v-for="item in items"
        v-bind="item"
        :key="item[itemKey]"
        :class="itemClass"
        :value="item[itemValue]"
      />
    </slot>
  </v-radio-group>
</template>

<script setup lang="ts">
export interface Props {
  label?: string
  itemClass?: string
  itemKey?: string
  items?: any[]
  itemValue?: string
}

withDefaults(defineProps<Props>(), {
  label: '',
  itemClass: undefined,
  itemKey: 'label',
  items: () => [],
  itemValue: 'id',
})
</script>
